document.addEventListener("DOMContentLoaded", function () {
  const ENDPOINT = "https://project-ih3nu.vercel.app/api/create-draft-order";
  const BM_LINK = "https://www.benjaminmoore.com/en-us/paint-colors/search";
  const STAIN_SOURCE = "Island Murphy Beds Stain Library";

  function num(v) {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  function getChecked(selector) {
    return document.querySelector(`${selector}:checked`);
  }

  function slugifyStainKey(value) {
    return String(value || "")
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  const previewStage = document.getElementById("preview-stage");
  const previewBase = document.getElementById("preview-base");
  const overlayDoor = document.getElementById("overlay-door");
  const overlayCrown = document.getElementById("overlay-crown");
  const overlayCabinetLeft = document.getElementById("overlay-cabinet-left");
  const overlayCabinetRight = document.getElementById("overlay-cabinet-right");
  const overlayTrayLeft = document.getElementById("overlay-tray-left");
  const overlayTrayRight = document.getElementById("overlay-tray-right");
  const overlayUpperLeft = document.getElementById("overlay-upper-left");
  const overlayUpperRight = document.getElementById("overlay-upper-right");
  const overlayDrawersLeft = document.getElementById("overlay-drawers-left");
  const overlayDrawersRight = document.getElementById("overlay-drawers-right");
  const overlayLowerLeft = document.getElementById("overlay-lower-left");
  const overlayLowerRight = document.getElementById("overlay-lower-right");

  const lowerDoorAssets = document.querySelector(".lower-door-assets");
  const trayAssets = document.querySelector(".tray-assets");
  const hiddenLeftCabinet = document.querySelector(
    ".cabinet-option:not(.second)"
  );
  const hiddenRightCabinet = document.querySelector(
    ".cabinet-option.second"
  );

  const basePriceEl = document.getElementById("base-price");
  const addonsPriceEl = document.getElementById("addons-price");
  const totalPriceEl = document.getElementById("total-price");

  const sizeField = document.getElementById("size-field");
  const doorField = document.getElementById("door-field");
  const crownField = document.getElementById("crown-field");
  const leftSideField = document.getElementById("left-side-field");
  const rightSideField = document.getElementById("right-side-field");
  const finishField = document.getElementById("finish-field");
  const colorField = document.getElementById("color-field");
  const mattressField = document.getElementById("mattress-field");
  const lightsField = document.getElementById("lights-field");
  const addonsField = document.getElementById("addons-field");
  const totalPriceField = document.getElementById("total-price-field");

  const paintColorNameField = document.getElementById(
    "paint-color-name-field"
  );
  const paintColorCodeField = document.getElementById(
    "paint-color-code-field"
  );
  const paintSourceField = document.getElementById(
    "paint-source-field"
  );

  const stainColorNameField = document.getElementById(
    "stain-color-name-field"
  );
  const stainColorCodeField = document.getElementById(
    "stain-color-code-field"
  );
  const stainSourceField = document.getElementById(
    "stain-source-field"
  );

  const sizeRadios = document.querySelectorAll(
    '.size-option input[type="radio"]'
  );
  const doorCards = document.querySelectorAll(".door-option");
  const crownRadios = document.querySelectorAll(
    '.crown-option input[type="radio"]'
  );
  const mattressRadios = document.querySelectorAll(
    '.mattress-options input[type="radio"]'
  );
  const lightsCheckbox = document.getElementById("lights");

  const stainCards = document.querySelectorAll(".stain-card");
  const paintCheckbox = document.getElementById("paintCheckbox");
  const bmPicker = document.getElementById("bmPaintPicker");
  const bmPresetRadios = bmPicker
    ? bmPicker.querySelectorAll('input[name="bm-color"]')
    : [];

  const leftToggle = document.querySelector(
    '.side-enable[data-side="left"]'
  );
  const rightToggle = document.querySelector(
    '.side-enable[data-side="right"]'
  );
  const leftAddonsBox = document.querySelector(".side-addons.left");
  const rightAddonsBox = document.querySelector(".side-addons.right");
  const leftDrawerGroup = document.querySelector(
    ".drawer-style-group.left"
  );
  const rightDrawerGroup = document.querySelector(
    ".drawer-style-group.right"
  );
  const leftUpperGroup = document.querySelector(
    ".upper-style-group.left"
  );
  const rightUpperGroup = document.querySelector(
    ".upper-style-group.right"
  );

  const progressFill = document.getElementById("progress-fill");
  const progressTotal = document.getElementById("progress-total");

  const statusSize = document.getElementById("status-size");
  const statusDoor = document.getElementById("status-door");
  const statusFinish = document.getElementById("status-finish");

  const paintPriceEl = document.getElementById("paintPrice");
  const paintBasePriceEl = document.getElementById("paintBasePrice");
  const paintAddAmountEl = document.getElementById("paintAddAmount");
  const paintTotalEl = document.getElementById("paintTotal");

  const resetButton = document.getElementById("preview-reset");
  const steps = document.querySelectorAll(".builder-step");
  const form = document.getElementById("murphy-form");

  let STAIN_PREVIEW_MAP = {};

  try {
    const stainMapScript = document.getElementById("stain-preview-map");

    STAIN_PREVIEW_MAP = stainMapScript
      ? JSON.parse(stainMapScript.textContent.trim() || "{}")
      : {};
  } catch (error) {
    console.warn("Invalid stain preview JSON", error);
    STAIN_PREVIEW_MAP = {};
  }

  const state = {
    size: "",
    sizePrice: 0,
    doorName: "",
    doorUpcharge: 0,
    crownName: "",
    crownPrice: 0,
    leftEnabled: false,
    rightEnabled: false,
    leftBase: 895,
    rightBase: 895,
    leftAddons: {},
    rightAddons: {},
    stainName: "",
    stainKey: "",
    stainHex: "",
    finish: "",
    paintPreset: "",
    paintCode: "",
    mattressName: "",
    mattressPrice: 0,
    lights: false,
    lightsPrice: 350
  };

  const imagePromiseCache = new Map();
  const imageReadyCache = new Set();
  let previewRenderVersion = 0;

  function getSelectedDoorCard() {
    return document.querySelector(".door-option.selected") || null;
  }

  function getSelectedStainCard() {
    return document.querySelector(".stain-card.is-selected") || null;
  }

  function getSelectedStainKey() {
    const card = getSelectedStainCard();

    if (!card) return "";

    return (
      card.dataset.key ||
      slugifyStainKey(card.dataset.name || "")
    );
  }

  function getDrawerStyleEl(side) {
    return getChecked(
      `.drawer-style-group.${side} input[type="radio"]`
    );
  }

  function getUpperStyleEl(side) {
    return getChecked(
      `.upper-style-group.${side} input[type="radio"]`
    );
  }

  function getStainAsset(...parts) {
    const key = getSelectedStainKey();

    const stainData =
      STAIN_PREVIEW_MAP[state.stainName] ||
      STAIN_PREVIEW_MAP[key] ||
      {};

    return stainData[parts.join("|")] || "";
  }

  function getDefaultPreviewAsset(el, baseAttr) {
    if (!el) return "";

    return (
      el.getAttribute(`${baseAttr}-default`) ||
      el.getAttribute(baseAttr) ||
      ""
    );
  }

  function getInlineStainPreviewAsset(el, baseAttr) {
    if (!el) return "";

    const stainKey = getSelectedStainKey();

    if (!stainKey) return "";

    return el.getAttribute(`${baseAttr}-${stainKey}`) || "";
  }

  function getPreviewAsset(el, baseAttr, legacyParts = []) {
    const fallback = getDefaultPreviewAsset(el, baseAttr);

    if (state.finish === "Paint") {
      return fallback;
    }

    return (
      getInlineStainPreviewAsset(el, baseAttr) ||
      getStainAsset(...legacyParts) ||
      fallback
    );
  }

  function getPreviewAssetWithFallbacks(el, baseAttrs = []) {
    if (!el) return "";

    for (const baseAttr of baseAttrs) {
      if (!baseAttr) continue;

      const src = getPreviewAsset(el, baseAttr, []);

      if (src) return src;
    }

    return "";
  }

  function isWideSide(side) {
    if (side === "left") {
      return !!state.leftAddons['Left: Make 22" Wide'];
    }

    if (side === "right") {
      return !!state.rightAddons['Right: Make 22" Wide'];
    }

    return false;
  }

  function getUpperDoorPrice(side) {
    return isWideSide(side) ? 225 : 175;
  }

  function updateUpperDoorPriceLabels() {
    ["left", "right"].forEach((side) => {
      const upperDoorInput = document.querySelector(
        `.toggle-upper[data-side="${side}"]`
      );

      if (!upperDoorInput) return;

      const price = getUpperDoorPrice(side);

      upperDoorInput.dataset.price = String(price);

      const label = upperDoorInput.closest("label");
      let optionText = label?.querySelector(".option-text");

      if (!optionText && label) {
        optionText = document.createElement("span");
        optionText.className = "option-text";
        label.appendChild(optionText);
      }

      if (optionText) {
        optionText.textContent = `Add Upper Door (+$${price})`;
      }
    });
  }

  function getCrownPlacementKey() {
    const leftOn = state.leftEnabled;
    const rightOn = state.rightEnabled;
    const leftWide = isWideSide("left");
    const rightWide = isWideSide("right");

    if (leftOn && rightOn) {
      return leftWide || rightWide ? "full-wide" : "full";
    }

    if (leftOn) {
      return leftWide ? "left-wide" : "left";
    }

    if (rightOn) {
      return rightWide ? "right-wide" : "right";
    }

    return "door";
  }

  function showBmPicker(show) {
    if (!bmPicker) return;

    bmPicker.style.display = show ? "block" : "none";
  }

  function pulsePreview() {
    if (!previewStage) return;

    previewStage.classList.remove("is-refreshing");
    void previewStage.offsetWidth;
    previewStage.classList.add("is-refreshing");
  }

  function setActiveStep(stepNo) {
    steps.forEach((step) => {
      step.classList.toggle(
        "is-active",
        step.dataset.step === String(stepNo)
      );
    });
  }

  function mapSideAddons(side) {
    const data = {};

    document
      .querySelectorAll(`.side-addon[data-side="${side}"]`)
      .forEach((input) => {
        data[input.dataset.name] = !!input.checked;
      });

    return data;
  }

  function ensureFirstChecked(groupEl) {
    if (!groupEl) return;

    const anyChecked = groupEl.querySelector(
      'input[type="radio"]:checked'
    );

    if (anyChecked) return;

    const first = groupEl.querySelector('input[type="radio"]');

    if (first) {
      first.checked = true;
    }
  }

  function clearCustomSelections() {
    sizeRadios.forEach((input, index) => {
      input.checked = index === 0;
    });

    crownRadios.forEach((input) => {
      input.checked = false;
    });

    mattressRadios.forEach((input) => {
      input.checked = false;
    });

    bmPresetRadios.forEach((input) => {
      input.checked = false;
    });

    document
      .querySelectorAll(
        'input[name="left-drawer-style"], input[name="right-drawer-style"]'
      )
      .forEach((input) => {
        input.checked = false;
      });

    document
      .querySelectorAll(
        'input[name="left-upper-style"], input[name="right-upper-style"]'
      )
      .forEach((input) => {
        input.checked = false;
      });

    if (paintCheckbox) paintCheckbox.checked = false;
    if (lightsCheckbox) lightsCheckbox.checked = false;
    if (leftToggle) leftToggle.checked = false;
    if (rightToggle) rightToggle.checked = false;

    document.querySelectorAll(".side-addon").forEach((input) => {
      input.checked = false;
    });

    doorCards.forEach((card) => {
      card.classList.remove("selected");
      delete card.dataset.preventReselectUntil;
    });

    stainCards.forEach((card) => {
      card.classList.remove("is-selected");
      delete card.dataset.preventReselectUntil;
    });

    document
      .querySelectorAll(
        ".size-option, .crown-option, .mattress-options label, .lights-option, .side-toggle, .side-addons > label, .drawer-style, .upper-style, .bm-option"
      )
      .forEach((el) => {
        el.classList.remove("is-selected");
        delete el.dataset.preventReselectUntil;
        delete el.dataset.wasChecked;
      });

    if (leftAddonsBox) leftAddonsBox.style.display = "none";
    if (rightAddonsBox) rightAddonsBox.style.display = "none";
    if (leftDrawerGroup) leftDrawerGroup.style.display = "none";
    if (rightDrawerGroup) rightDrawerGroup.style.display = "none";
    if (leftUpperGroup) leftUpperGroup.style.display = "none";
    if (rightUpperGroup) rightUpperGroup.style.display = "none";

    showBmPicker(false);
  }

  function hydrateStateFromDOM() {
    const size = getChecked('.size-option input[type="radio"]');
    const door = getSelectedDoorCard();
    const crown = getChecked('.crown-option input[type="radio"]');
    const mattress = getChecked(
      '.mattress-options input[type="radio"]'
    );
    const selectedStain = getSelectedStainCard();
    const selectedPaint = getChecked(
      "#bmPaintPicker input[name='bm-color']"
    );

    state.size = size ? size.value : "";
    state.sizePrice = size ? num(size.dataset.price) : 0;

    state.doorName = door ? door.dataset.value : "";
    state.doorUpcharge = door ? num(door.dataset.price) : 0;

    state.crownName = crown ? crown.value : "";
    state.crownPrice = crown ? num(crown.dataset.price) : 0;

    state.leftEnabled = !!leftToggle?.checked;
    state.rightEnabled = !!rightToggle?.checked;

    state.leftBase = num(leftToggle?.dataset.base || 895);
    state.rightBase = num(rightToggle?.dataset.base || 895);

    state.leftAddons = mapSideAddons("left");
    state.rightAddons = mapSideAddons("right");

    state.stainName = selectedStain
      ? selectedStain.dataset.name || ""
      : "";

    state.stainKey = selectedStain
      ? selectedStain.dataset.key ||
        slugifyStainKey(selectedStain.dataset.name || "")
      : "";

    state.stainHex = selectedStain
      ? selectedStain.dataset.hex || ""
      : "";

    state.finish = paintCheckbox?.checked
      ? "Paint"
      : selectedStain
        ? "Stained and Lacquer"
        : "";

    state.paintPreset = selectedPaint
      ? selectedPaint.value
      : "";

    state.paintCode = selectedPaint
      ? selectedPaint.dataset.code || ""
      : "";

    state.mattressName = mattress ? mattress.value : "";
    state.mattressPrice = mattress
      ? num(mattress.dataset.price)
      : 0;

    state.lights = !!lightsCheckbox?.checked;
    state.lightsPrice = num(
      lightsCheckbox?.dataset.price || 350
    );
  }

  function syncSelectableClasses() {
    const selectors = [
      ".size-option",
      ".crown-option",
      ".mattress-options label",
      ".lights-option",
      ".side-toggle",
      ".side-addons > label",
      ".drawer-style",
      ".upper-style",
      ".bm-option"
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        const input = el.querySelector("input");

        el.classList.toggle(
          "is-selected",
          !!input?.checked
        );
      });
    });
  }

  function getLowerDoorVariant() {
    const doorName = (state.doorName || "").toLowerCase();

    if (
      doorName.includes("shaker") ||
      doorName.includes("rockland") ||
      doorName.includes("douglas")
    ) {
      return "shaker";
    }

    return "flat";
  }

  function preloadImage(url) {
    if (!url) {
      return Promise.resolve("");
    }

    if (imagePromiseCache.has(url)) {
      return imagePromiseCache.get(url);
    }

    const promise = new Promise((resolve) => {
      const img = new Image();

      const done = () => {
        const finalize = () => {
          imageReadyCache.add(url);
          resolve(url);
        };

        if (typeof img.decode === "function") {
          img.decode().then(finalize).catch(finalize);
        } else {
          finalize();
        }
      };

      img.onload = done;
      img.onerror = () => resolve("");
      img.src = url;

      if (img.complete) {
        done();
      }
    });

    imagePromiseCache.set(url, promise);

    return promise;
  }

  function preloadImages(urls) {
    const uniqueUrls = [
      ...new Set((urls || []).filter(Boolean))
    ];

    if (!uniqueUrls.length) {
      return Promise.resolve();
    }

    return Promise.all(uniqueUrls.map(preloadImage));
  }

  function collectDataAttributeUrls(root) {
    const urls = [];

    if (!root || !root.attributes) {
      return urls;
    }

    Array.from(root.attributes).forEach((attr) => {
      const name = attr.name || "";
      const value = attr.value || "";

      if (!name.startsWith("data-")) return;
      if (!value) return;

      if (/^https?:\/\//i.test(value)) {
        urls.push(value);
      }
    });

    return urls;
  }

  function warmPreloadAllPreviewAssets() {
    const allUrls = [];

    const sources = [
      previewBase,
      ...doorCards,
      ...crownRadios,
      hiddenLeftCabinet,
      hiddenRightCabinet,
      lowerDoorAssets,
      trayAssets,
      ...document.querySelectorAll(
        'input[name="left-drawer-style"]'
      ),
      ...document.querySelectorAll(
        'input[name="right-drawer-style"]'
      ),
      ...document.querySelectorAll(
        'input[name="left-upper-style"]'
      ),
      ...document.querySelectorAll(
        'input[name="right-upper-style"]'
      )
    ];

    sources.forEach((el) => {
      allUrls.push(...collectDataAttributeUrls(el));
    });

    const run = () => preloadImages(allUrls);

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(run, {
        timeout: 1200
      });
    } else {
      setTimeout(run, 120);
    }
  }

  function buildPreviewPlan() {
    const selectedDoor = getSelectedDoorCard();
    const crown = getChecked('.crown-option input[type="radio"]');
    const crownPlacementKey = getCrownPlacementKey();
    const lowerDoorVariant = getLowerDoorVariant();

    const leftDrawerStyleEl = getDrawerStyleEl("left");
    const rightDrawerStyleEl = getDrawerStyleEl("right");
    const leftUpperStyleEl = getUpperStyleEl("left");
    const rightUpperStyleEl = getUpperStyleEl("right");

    const leftWide = isWideSide("left");
    const rightWide = isWideSide("right");

    const plan = {
      base: {
        el: previewBase,
        src: "",
        show: true
      },
      door: {
        el: overlayDoor,
        src: "",
        show: false
      },
      crown: {
        el: overlayCrown,
        src: "",
        show: false
      },
      cabinetLeft: {
        el: overlayCabinetLeft,
        src: "",
        show: false
      },
      cabinetRight: {
        el: overlayCabinetRight,
        src: "",
        show: false
      },
      trayLeft: {
        el: overlayTrayLeft,
        src: "",
        show: false
      },
      trayRight: {
        el: overlayTrayRight,
        src: "",
        show: false
      },
      lowerLeft: {
        el: overlayLowerLeft,
        src: "",
        show: false
      },
      lowerRight: {
        el: overlayLowerRight,
        src: "",
        show: false
      },
      drawersLeft: {
        el: overlayDrawersLeft,
        src: "",
        show: false
      },
      drawersRight: {
        el: overlayDrawersRight,
        src: "",
        show: false
      },
      upperLeft: {
        el: overlayUpperLeft,
        src: "",
        show: false
      },
      upperRight: {
        el: overlayUpperRight,
        src: "",
        show: false
      }
    };

    const baseSrc = getPreviewAsset(
      previewBase,
      "data-image",
      ["base", "bed"]
    );

    plan.base.src =
      baseSrc ||
      previewBase?.getAttribute("src") ||
      "";

    plan.base.show = !!plan.base.src;

    if (state.doorName) {
      const doorSrc = getPreviewAsset(
        selectedDoor,
        "data-image",
        ["door", state.doorName]
      );

      plan.door.src = doorSrc;
      plan.door.show = !!doorSrc;
    }

    if (
      crown &&
      state.crownName &&
      state.crownName !== "No Crown"
    ) {
      const crownBasesByPlacement = {
        door: ["data-door"],
        "door-wide": ["data-door-wide"],
        left: ["data-left"],
        "left-wide": ["data-left-wide"],
        right: ["data-right"],
        "right-wide": ["data-right-wide"],
        full: ["data-full"],
        "full-wide": ["data-full-wide"]
      };

      const crownBases =
        crownBasesByPlacement[crownPlacementKey] ||
        ["data-door"];

      const crownSrc =
        getPreviewAssetWithFallbacks(
          crown,
          crownBases
        );

      plan.crown.src = crownSrc;
      plan.crown.show = !!crownSrc;
    }

    if (state.leftEnabled) {
      const leftCabBases = leftWide
        ? ["data-left-wide"]
        : ["data-left"];

      const leftCabSrc =
        getPreviewAssetWithFallbacks(
          hiddenLeftCabinet,
          leftCabBases
        );

      const leftLowerBases = leftWide
        ? [`data-left-${lowerDoorVariant}-wide`]
        : [`data-left-${lowerDoorVariant}`];

      const leftLowerSrc =
        getPreviewAssetWithFallbacks(
          lowerDoorAssets,
          leftLowerBases
        );

      plan.cabinetLeft.src = leftCabSrc;
      plan.cabinetLeft.show = !!leftCabSrc;

      plan.lowerLeft.src = leftLowerSrc;
      plan.lowerLeft.show = !!leftLowerSrc;

      if (state.leftAddons["Left: Pull-Out Tray"]) {
        const leftTrayBases = leftWide
          ? ["data-left-wide"]
          : ["data-left"];

        const leftTraySrc =
          getPreviewAssetWithFallbacks(
            trayAssets,
            leftTrayBases
          );

        plan.trayLeft.src = leftTraySrc;
        plan.trayLeft.show = !!leftTraySrc;
      }

      if (state.leftAddons["Left: Add Two Drawers"]) {
        const leftDrawerBases = leftWide
          ? ["data-left-wide"]
          : ["data-left"];

        const leftDrawerSrc =
          getPreviewAssetWithFallbacks(
            leftDrawerStyleEl,
            leftDrawerBases
          );

        plan.drawersLeft.src = leftDrawerSrc;
        plan.drawersLeft.show = !!leftDrawerSrc;
      }

      if (state.leftAddons["Left: Add Upper Door"]) {
        const leftUpperBases = leftWide
          ? ["data-left-wide"]
          : ["data-left"];

        const leftUpperSrc =
          getPreviewAssetWithFallbacks(
            leftUpperStyleEl,
            leftUpperBases
          );

        plan.upperLeft.src = leftUpperSrc;
        plan.upperLeft.show = !!leftUpperSrc;
      }
    }

    if (state.rightEnabled) {
      const rightCabBases = rightWide
        ? ["data-right-wide"]
        : ["data-right"];

      const rightCabSrc =
        getPreviewAssetWithFallbacks(
          hiddenRightCabinet,
          rightCabBases
        );

      const rightLowerBases = rightWide
        ? [`data-right-${lowerDoorVariant}-wide`]
        : [`data-right-${lowerDoorVariant}`];

      const rightLowerSrc =
        getPreviewAssetWithFallbacks(
          lowerDoorAssets,
          rightLowerBases
        );

      plan.cabinetRight.src = rightCabSrc;
      plan.cabinetRight.show = !!rightCabSrc;

      plan.lowerRight.src = rightLowerSrc;
      plan.lowerRight.show = !!rightLowerSrc;

      if (state.rightAddons["Right: Pull-Out Tray"]) {
        const rightTrayBases = rightWide
          ? ["data-right-wide"]
          : ["data-right"];

        const rightTraySrc =
          getPreviewAssetWithFallbacks(
            trayAssets,
            rightTrayBases
          );

        plan.trayRight.src = rightTraySrc;
        plan.trayRight.show = !!rightTraySrc;
      }

      if (state.rightAddons["Right: Add Two Drawers"]) {
        const rightDrawerBases = rightWide
          ? ["data-right-wide"]
          : ["data-right"];

        const rightDrawerSrc =
          getPreviewAssetWithFallbacks(
            rightDrawerStyleEl,
            rightDrawerBases
          );

        plan.drawersRight.src = rightDrawerSrc;
        plan.drawersRight.show = !!rightDrawerSrc;
      }

      if (state.rightAddons["Right: Add Upper Doors"]) {
        const rightUpperBases = rightWide
          ? ["data-right-wide"]
          : ["data-right"];

        const rightUpperSrc =
          getPreviewAssetWithFallbacks(
            rightUpperStyleEl,
            rightUpperBases
          );

        plan.upperRight.src = rightUpperSrc;
        plan.upperRight.show = !!rightUpperSrc;
      }
    }

    return plan;
  }

  function setLayerImage(item, renderVersion) {
    if (!item || !item.el) return;

    const el = item.el;
    const src = item.src || "";
    const show = !!item.show && !!src;

    if (!show) {
      if (el.id !== "preview-base") {
        el.style.display = "none";
      }

      delete el.dataset.desiredSrc;
      return;
    }

    el.dataset.desiredSrc = src;

    if (el.getAttribute("src") === src) {
      el.style.display = "block";
      return;
    }

    const applyNow = () => {
      if (renderVersion !== previewRenderVersion) return;
      if (el.dataset.desiredSrc !== src) return;

      el.setAttribute("src", src);
      el.style.display = "block";
    };

    if (imageReadyCache.has(src)) {
      applyNow();
      return;
    }

    preloadImage(src).then((loadedUrl) => {
      if (!loadedUrl) return;

      applyNow();
    });
  }

  function applyPreviewPlan(plan, renderVersion) {
    Object.values(plan).forEach((item) => {
      setLayerImage(item, renderVersion);
    });
  }

  function updateAllImages(animate = false) {
    const renderVersion = ++previewRenderVersion;
    const plan = buildPreviewPlan();

    applyPreviewPlan(plan, renderVersion);

    if (animate) {
      pulsePreview();
    }
  }

  function sidesTotal() {
    let total = 0;

    if (state.leftEnabled) {
      total += state.leftBase;

      if (state.leftAddons['Left: Make 22" Wide']) {
        total += 100;
      }

      if (state.leftAddons["Left: Add Two Drawers"]) {
        total += 200;
      }

      if (state.leftAddons["Left: Add Upper Door"]) {
        total += getUpperDoorPrice("left");
      }

      if (state.leftAddons["Left: Pull-Out Tray"]) {
        total += 200;
      }
    }

    if (state.rightEnabled) {
      total += state.rightBase;

      if (state.rightAddons['Right: Make 22" Wide']) {
        total += 100;
      }

      if (state.rightAddons["Right: Add Two Drawers"]) {
        total += 200;
      }

      if (state.rightAddons["Right: Add Upper Doors"]) {
        total += getUpperDoorPrice("right");
      }

      if (state.rightAddons["Right: Pull-Out Tray"]) {
        total += 200;
      }
    }

    return total;
  }

  function preFinishSubtotal() {
    return (
      state.sizePrice +
      state.doorUpcharge +
      state.crownPrice +
      sidesTotal() +
      state.mattressPrice +
      (state.lights ? state.lightsPrice : 0)
    );
  }

  function paintPercent() {
    const p = parseFloat(
      paintCheckbox?.dataset.percent || "5"
    );

    return isNaN(p) ? 0.05 : p / 100;
  }

  function finishCharge(pre) {
    return state.finish === "Paint"
      ? pre * paintPercent()
      : 0;
  }

  function updatePaintBreakdown(preSubtotal) {
    const enabled = !!paintCheckbox?.checked;

    const add = enabled
      ? preSubtotal * paintPercent()
      : 0;

    const total = preSubtotal + add;

    if (paintPriceEl) {
      paintPriceEl.textContent = enabled
        ? `+$${add.toFixed(0)}`
        : "+$0";
    }

    if (paintBasePriceEl) {
      paintBasePriceEl.textContent =
        `$${preSubtotal.toFixed(0)}`;
    }

    if (paintAddAmountEl) {
      paintAddAmountEl.textContent =
        `$${add.toFixed(0)}`;
    }

    if (paintTotalEl) {
      paintTotalEl.textContent =
        `$${total.toFixed(0)}`;
    }
  }

  function updatePreviewStatus() {
    if (statusSize) {
      statusSize.textContent =
        state.size || "No Size";
    }

    if (statusDoor) {
      statusDoor.textContent =
        state.doorName || "No Door";
    }

    if (state.finish === "Paint") {
      if (statusFinish) {
        statusFinish.textContent =
          state.paintPreset || "Paint";
      }
    } else if (
      state.finish === "Stained and Lacquer"
    ) {
      if (statusFinish) {
        statusFinish.textContent =
          state.stainName || "No Finish";
      }
    } else {
      if (statusFinish) {
        statusFinish.textContent = "No Finish";
      }
    }
  }

  function updateStepCompletion() {
    const completed = {
      1: !!state.size && !!state.doorName,
      2: !!state.crownName,
      3: state.leftEnabled || state.rightEnabled,
      4:
        state.finish === "Paint"
          ? !!state.paintPreset
          : !!state.stainName,
      5: !!state.mattressName,
      6: !!state.lights
    };

    steps.forEach((step) => {
      const stepNo = step.dataset.step;

      step.classList.toggle(
        "is-complete",
        !!completed[stepNo]
      );
    });

    const totalCompleted = Object.values(
      completed
    ).filter(Boolean).length;

    const percentage =
      (totalCompleted / 6) * 100;

    if (progressFill) {
      progressFill.style.width =
        `${percentage}%`;
    }

    if (progressTotal) {
      progressTotal.textContent =
        `${totalCompleted} / 6 customized`;
    }
  }

  function updateTotals() {
    const pre = preFinishSubtotal();
    const fin = finishCharge(pre);

    updatePaintBreakdown(pre);

    const addOnsShown =
      state.doorUpcharge +
      state.crownPrice +
      sidesTotal() +
      state.mattressPrice +
      (state.lights
        ? state.lightsPrice
        : 0) +
      fin;

    const grand =
      state.sizePrice + addOnsShown;

    if (basePriceEl) {
      basePriceEl.textContent =
        state.sizePrice.toFixed(0);
    }

    if (addonsPriceEl) {
      addonsPriceEl.textContent =
        addOnsShown.toFixed(0);
    }

    if (totalPriceEl) {
      totalPriceEl.textContent =
        grand.toFixed(0);
    }

    if (totalPriceField) {
      totalPriceField.value =
        `$${grand.toFixed(2)}`;
    }

    const leftSummary = state.leftEnabled
      ? [
          `Base $${state.leftBase}`,

          state.leftAddons[
            'Left: Make 22" Wide'
          ]
            ? '22" Wide (+$100)'
            : null,

          state.leftAddons[
            "Left: Add Two Drawers"
          ]
            ? `Drawers: ${
                getDrawerStyleEl("left")
                  ?.value || "Style"
              } (+$200)`
            : null,

          state.leftAddons[
            "Left: Add Upper Door"
          ]
            ? `Upper: ${
                getUpperStyleEl("left")
                  ?.value || "Style"
              } (+$${getUpperDoorPrice("left")})`
            : null,

          state.leftAddons[
            "Left: Pull-Out Tray"
          ]
            ? "Pull-Out Tray (+$200)"
            : null
        ]
          .filter(Boolean)
          .join(", ")
      : "None";

    const rightSummary = state.rightEnabled
      ? [
          `Base $${state.rightBase}`,

          state.rightAddons[
            'Right: Make 22" Wide'
          ]
            ? '22" Wide (+$100)'
            : null,

          state.rightAddons[
            "Right: Add Two Drawers"
          ]
            ? `Drawers: ${
                getDrawerStyleEl("right")
                  ?.value || "Style"
              } (+$200)`
            : null,

          state.rightAddons[
            "Right: Add Upper Doors"
          ]
            ? `Upper: ${
                getUpperStyleEl("right")
                  ?.value || "Style"
              } (+$${getUpperDoorPrice("right")})`
            : null,

          state.rightAddons[
            "Right: Pull-Out Tray"
          ]
            ? "Pull-Out Tray (+$200)"
            : null
        ]
          .filter(Boolean)
          .join(", ")
      : "None";

    if (sizeField) {
      sizeField.value = state.size || "";
    }

    if (doorField) {
      doorField.value =
        state.doorName || "";
    }

    if (crownField) {
      crownField.value =
        state.crownName || "";
    }

    if (leftSideField) {
      leftSideField.value = leftSummary;
    }

    if (rightSideField) {
      rightSideField.value = rightSummary;
    }

    if (finishField) {
      finishField.value =
        state.finish || "";
    }

    if (mattressField) {
      mattressField.value =
        state.mattressName || "";
    }

    if (lightsField) {
      lightsField.value = state.lights
        ? "Yes (+$350)"
        : "No";
    }

    if (state.finish === "Paint") {
      if (colorField) {
        colorField.value =
          state.paintPreset
            ? `Paint: ${state.paintPreset}`
            : "Paint";
      }

      if (paintColorNameField) {
        paintColorNameField.value =
          state.paintPreset || "";
      }

      if (paintColorCodeField) {
        paintColorCodeField.value =
          state.paintCode || "";
      }

      if (paintSourceField) {
        paintSourceField.value = BM_LINK;
      }

      if (stainColorNameField) {
        stainColorNameField.value = "";
      }

      if (stainColorCodeField) {
        stainColorCodeField.value = "";
      }

      if (stainSourceField) {
        stainSourceField.value = "";
      }
    } else if (
      state.finish === "Stained and Lacquer"
    ) {
      if (colorField) {
        colorField.value =
          `Stain: ${state.stainName}`;
      }

      if (stainColorNameField) {
        stainColorNameField.value =
          state.stainName || "";
      }

      if (stainColorCodeField) {
        stainColorCodeField.value =
          state.stainHex || "";
      }

      if (stainSourceField) {
        stainSourceField.value =
          STAIN_SOURCE;
      }

      if (paintColorNameField) {
        paintColorNameField.value = "";
      }

      if (paintColorCodeField) {
        paintColorCodeField.value = "";
      }

      if (paintSourceField) {
        paintSourceField.value = "";
      }
    } else {
      if (colorField) {
        colorField.value = "";
      }

      if (paintColorNameField) {
        paintColorNameField.value = "";
      }

      if (paintColorCodeField) {
        paintColorCodeField.value = "";
      }

      if (paintSourceField) {
        paintSourceField.value = "";
      }

      if (stainColorNameField) {
        stainColorNameField.value = "";
      }

      if (stainColorCodeField) {
        stainColorCodeField.value = "";
      }

      if (stainSourceField) {
        stainSourceField.value = "";
      }
    }

    const addons = [];

    if (state.size) {
      addons.push(`Size: ${state.size}`);
    }

    if (state.doorName) {
      addons.push(
        state.doorUpcharge
          ? `Door: ${state.doorName} (+$${state.doorUpcharge})`
          : `Door: ${state.doorName} (Included)`
      );
    }

    if (state.crownName) {
      addons.push(
        state.crownName === "No Crown"
          ? `Crown: ${state.crownName}`
          : `Crown: ${state.crownName} (+$${state.crownPrice})`
      );
    }

    if (state.leftEnabled) {
      addons.push(
        `Left Side: ${leftSummary}`
      );
    }

    if (state.rightEnabled) {
      addons.push(
        `Right Side: ${rightSummary}`
      );
    }

    if (state.finish === "Paint") {
      addons.push(
        `Finish: Paint (+${(
          paintPercent() * 100
        ).toFixed(0)}%)`
      );

      if (state.paintPreset) {
        addons.push(
          `Paint Color: ${state.paintPreset}`
        );
      }

      addons.push(
        `Paint Library: ${BM_LINK}`
      );
    } else if (
      state.finish === "Stained and Lacquer"
    ) {
      addons.push(
        "Finish: Stained and Lacquer (Included)"
      );

      addons.push(
        `Stain: ${state.stainName}`
      );

      addons.push(
        `Stain Code: ${state.stainHex}`
      );
    }

    if (state.mattressName) {
      addons.push(
        state.mattressPrice
          ? `Mattress: ${state.mattressName} (+$${state.mattressPrice})`
          : `Mattress: ${state.mattressName}`
      );
    }

    if (state.lights) {
      addons.push("Lights (+$350)");
    }

    if (addonsField) {
      addonsField.value =
        addons.join(" | ");
    }
  }

  function refresh(animate = false) {
    hydrateStateFromDOM();
    updateUpperDoorPriceLabels();
    syncSelectableClasses();
    showBmPicker(!!paintCheckbox?.checked);
    updateAllImages(animate);
    updateTotals();
    updatePreviewStatus();
    updateStepCompletion();
  }

  function bindToggleableRadioChoices(
    containerSelector,
    stepNo
  ) {
    document
      .querySelectorAll(containerSelector)
      .forEach((container) => {
        const input =
          container.querySelector(
            'input[type="radio"]'
          );

        if (!input) return;

        const rememberState = () => {
          container.dataset.wasChecked =
            input.checked
              ? "true"
              : "false";
        };

        container.addEventListener(
          "pointerdown",
          rememberState
        );

        container.addEventListener(
          "mousedown",
          rememberState
        );

        container.addEventListener(
          "touchstart",
          rememberState,
          {
            passive: true
          }
        );

        container.addEventListener(
          "click",
          function (e) {
            const now = Date.now();

            const preventUntil = num(
              container.dataset
                .preventReselectUntil || 0
            );

            const wasChecked =
              container.dataset.wasChecked ===
              "true";

            if (
              preventUntil &&
              now < preventUntil
            ) {
              e.preventDefault();

              input.checked = false;

              container.dataset.wasChecked =
                "false";

              setActiveStep(stepNo);
              refresh(true);

              return;
            }

            if (wasChecked) {
              e.preventDefault();

              input.checked = false;

              container.dataset.wasChecked =
                "false";

              container.dataset
                .preventReselectUntil =
                String(now + 280);

              setActiveStep(stepNo);
              refresh(true);
            }
          }
        );

        container.addEventListener(
          "dblclick",
          function (e) {
            e.preventDefault();

            input.checked = false;

            container.dataset.wasChecked =
              "false";

            container.dataset
              .preventReselectUntil =
              String(Date.now() + 280);

            setActiveStep(stepNo);
            refresh(true);
          }
        );
      });
  }

  window.selStain = function (card) {
    if (!card) return;

    const now = Date.now();

    const preventUntil = num(
      card.dataset.preventReselectUntil || 0
    );

    const alreadySelected =
      card.classList.contains("is-selected");

    if (
      preventUntil &&
      now < preventUntil
    ) {
      card.classList.remove("is-selected");

      setActiveStep(4);
      refresh(true);

      return;
    }

    if (alreadySelected) {
      card.classList.remove("is-selected");

      card.dataset.preventReselectUntil =
        String(now + 280);

      if (paintCheckbox) {
        paintCheckbox.checked = false;
      }

      showBmPicker(false);

      setActiveStep(4);
      refresh(true);

      return;
    }

    stainCards.forEach((c) => {
      c.classList.remove("is-selected");
    });

    card.classList.add("is-selected");

    if (paintCheckbox) {
      paintCheckbox.checked = false;
    }

    showBmPicker(false);

    setActiveStep(4);
    refresh(true);
  };

  window.togglePaint = function () {
    const isOn =
      !!paintCheckbox?.checked;

    showBmPicker(isOn);

    if (!isOn) {
      document
        .querySelectorAll(
          '#bmPaintPicker input[name="bm-color"]'
        )
        .forEach((input) => {
          input.checked = false;
        });
    }

    setActiveStep(4);
    refresh(true);
  };

  function bindDoorCards() {
    doorCards.forEach((card) => {
      card.addEventListener(
        "click",
        function () {
          const now = Date.now();

          const preventUntil = num(
            card.dataset
              .preventReselectUntil || 0
          );

          const alreadySelected =
            card.classList.contains(
              "selected"
            );

          if (
            preventUntil &&
            now < preventUntil
          ) {
            card.classList.remove(
              "selected"
            );

            setActiveStep(1);
            refresh(true);

            return;
          }

          if (alreadySelected) {
            card.classList.remove(
              "selected"
            );

            card.dataset
              .preventReselectUntil =
              String(now + 280);

            setActiveStep(1);
            refresh(true);

            return;
          }

          doorCards.forEach((c) => {
            c.classList.remove("selected");
          });

          card.classList.add("selected");

          setActiveStep(1);
          refresh(true);
        }
      );

      card.addEventListener(
        "dblclick",
        function (e) {
          e.preventDefault();

          card.classList.remove(
            "selected"
          );

          card.dataset
            .preventReselectUntil =
            String(Date.now() + 280);

          setActiveStep(1);
          refresh(true);
        }
      );
    });
  }

  function bindRadioGroups() {
    sizeRadios.forEach((input) => {
      input.addEventListener(
        "change",
        () => {
          setActiveStep(1);
          refresh(true);
        }
      );
    });

    crownRadios.forEach((input) => {
      input.addEventListener(
        "change",
        () => {
          setActiveStep(2);
          refresh(true);
        }
      );
    });

    mattressRadios.forEach((input) => {
      input.addEventListener(
        "change",
        () => {
          setActiveStep(5);
          refresh(true);
        }
      );
    });

    bmPresetRadios.forEach((input) => {
      input.addEventListener(
        "change",
        () => {
          setActiveStep(4);
          refresh(true);
        }
      );
    });

    document
      .querySelectorAll(
        'input[name="left-drawer-style"], input[name="right-drawer-style"]'
      )
      .forEach((input) => {
        input.addEventListener(
          "change",
          () => {
            setActiveStep(3);
            refresh(true);
          }
        );
      });

    document
      .querySelectorAll(
        'input[name="left-upper-style"], input[name="right-upper-style"]'
      )
      .forEach((input) => {
        input.addEventListener(
          "change",
          () => {
            setActiveStep(3);
            refresh(true);
          }
        );
      });

    bindToggleableRadioChoices(
      ".crown-option",
      2
    );

    bindToggleableRadioChoices(
      ".mattress-options label",
      5
    );

    bindToggleableRadioChoices(
      ".bm-option",
      4
    );

    bindToggleableRadioChoices(
      ".drawer-style",
      3
    );

    bindToggleableRadioChoices(
      ".upper-style",
      3
    );
  }

  function bindCheckboxes() {
    if (leftToggle) {
      leftToggle.addEventListener(
        "change",
        () => {
          if (leftAddonsBox) {
            leftAddonsBox.style.display =
              leftToggle.checked
                ? "block"
                : "none";
          }

          if (!leftToggle.checked) {
            document
              .querySelectorAll(
                '.side-addon[data-side="left"]'
              )
              .forEach((input) => {
                input.checked = false;
              });

            document
              .querySelectorAll(
                'input[name="left-drawer-style"], input[name="left-upper-style"]'
              )
              .forEach((input) => {
                input.checked = false;
              });

            if (leftDrawerGroup) {
              leftDrawerGroup.style.display =
                "none";
            }

            if (leftUpperGroup) {
              leftUpperGroup.style.display =
                "none";
            }
          } else {
            if (
              leftDrawerGroup &&
              document.querySelector(
                '.toggle-drawer[data-side="left"]'
              )?.checked
            ) {
              leftDrawerGroup.style.display =
                "block";

              ensureFirstChecked(
                leftDrawerGroup
              );
            }

            if (
              leftUpperGroup &&
              document.querySelector(
                '.toggle-upper[data-side="left"]'
              )?.checked
            ) {
              leftUpperGroup.style.display =
                "block";

              ensureFirstChecked(
                leftUpperGroup
              );
            }
          }

          setActiveStep(3);
          refresh(true);
        }
      );
    }

    if (rightToggle) {
      rightToggle.addEventListener(
        "change",
        () => {
          if (rightAddonsBox) {
            rightAddonsBox.style.display =
              rightToggle.checked
                ? "block"
                : "none";
          }

          if (!rightToggle.checked) {
            document
              .querySelectorAll(
                '.side-addon[data-side="right"]'
              )
              .forEach((input) => {
                input.checked = false;
              });

            document
              .querySelectorAll(
                'input[name="right-drawer-style"], input[name="right-upper-style"]'
              )
              .forEach((input) => {
                input.checked = false;
              });

            if (rightDrawerGroup) {
              rightDrawerGroup.style.display =
                "none";
            }

            if (rightUpperGroup) {
              rightUpperGroup.style.display =
                "none";
            }
          } else {
            if (
              rightDrawerGroup &&
              document.querySelector(
                '.toggle-drawer[data-side="right"]'
              )?.checked
            ) {
              rightDrawerGroup.style.display =
                "block";

              ensureFirstChecked(
                rightDrawerGroup
              );
            }

            if (
              rightUpperGroup &&
              document.querySelector(
                '.toggle-upper[data-side="right"]'
              )?.checked
            ) {
              rightUpperGroup.style.display =
                "block";

              ensureFirstChecked(
                rightUpperGroup
              );
            }
          }

          setActiveStep(3);
          refresh(true);
        }
      );
    }

    document
      .querySelectorAll(".side-addon")
      .forEach((chk) => {
        chk.addEventListener(
          "change",
          () => {
            const side =
              chk.dataset.side;

            if (
              chk.classList.contains(
                "toggle-drawer"
              )
            ) {
              const group =
                side === "left"
                  ? leftDrawerGroup
                  : rightDrawerGroup;

              if (group) {
                group.style.display =
                  chk.checked
                    ? "block"
                    : "none";

                if (chk.checked) {
                  ensureFirstChecked(group);
                } else {
                  group
                    .querySelectorAll(
                      'input[type="radio"]'
                    )
                    .forEach((input) => {
                      input.checked = false;
                    });
                }
              }
            }

            if (
              chk.classList.contains(
                "toggle-upper"
              )
            ) {
              const group =
                side === "left"
                  ? leftUpperGroup
                  : rightUpperGroup;

              if (group) {
                group.style.display =
                  chk.checked
                    ? "block"
                    : "none";

                if (chk.checked) {
                  ensureFirstChecked(group);
                } else {
                  group
                    .querySelectorAll(
                      'input[type="radio"]'
                    )
                    .forEach((input) => {
                      input.checked = false;
                    });
                }
              }
            }

            setActiveStep(3);
            refresh(true);
          }
        );
      });

    if (lightsCheckbox) {
      lightsCheckbox.addEventListener(
        "change",
        () => {
          setActiveStep(6);
          refresh(true);
        }
      );
    }
  }

  function resetBuilder() {
    if (form) {
      form.reset();
    }

    clearCustomSelections();
    setActiveStep(1);
    refresh(true);
  }

  async function createDraftOrder(total) {
    const props = {
      Size: sizeField?.value || "",
      Door: doorField?.value || "",
      Crown: crownField?.value || "",
      "Left Side": leftSideField?.value || "",
      "Right Side": rightSideField?.value || "",
      Finish: finishField?.value || "",
      Color: colorField?.value || "",
      Mattress: mattressField?.value || "",
      Lights: lightsField?.value || "",
      "Addons Summary": addonsField?.value || "",
      "Calculated Price":
        totalPriceField?.value ||
        `$${num(total).toFixed(2)}`
    };

    if (state.finish === "Paint") {
      props["Paint Selection"] =
        state.paintPreset || "";

      props["Paint Color Code"] =
        state.paintCode || "";

      props["Paint Color Library"] =
        BM_LINK;
    } else if (
      state.finish === "Stained and Lacquer"
    ) {
      props["Stain Name"] =
        state.stainName || "";

      props["Stain Code"] =
        state.stainHex || "";

      props["Stain Source"] =
        STAIN_SOURCE;
    }

    const payload = {
      title: "Murphy Bed (Customizable)",
      price: num(total),
      quantity: 1,
      properties: props
    };

    const response = await fetch(
      ENDPOINT,
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    const data = await response
      .json()
      .catch(() => ({}));

    if (
      !response.ok ||
      !data ||
      data.ok !== true
    ) {
      throw new Error(
        data?.error ||
        "Draft order API failed."
      );
    }

    return data.invoice_url;
  }

  function setLoading(isLoading) {
    const btn = document.querySelector(
      "#murphy-form button[type='submit']"
    );

    if (!btn) return;

    if (isLoading) {
      btn.disabled = true;
      btn.dataset.originalText =
        btn.textContent;
      btn.textContent = "Please wait…";
    } else {
      btn.disabled = false;
      btn.textContent =
        btn.dataset.originalText ||
        "Add to Cart";
    }
  }

  bindDoorCards();
  bindRadioGroups();
  bindCheckboxes();

  stainCards.forEach((card) => {
    card.addEventListener(
      "dblclick",
      function (e) {
        e.preventDefault();

        card.classList.remove(
          "is-selected"
        );

        card.dataset
          .preventReselectUntil =
          String(Date.now() + 280);

        setActiveStep(4);
        refresh(true);
      }
    );
  });

  if (resetButton) {
    resetButton.addEventListener(
      "click",
      resetBuilder
    );
  }

  if (form) {
    form.addEventListener(
      "submit",
      async function (e) {
        e.preventDefault();

        hydrateStateFromDOM();

        const total =
          state.sizePrice +
          state.doorUpcharge +
          state.crownPrice +
          sidesTotal() +
          state.mattressPrice +
          (state.lights
            ? state.lightsPrice
            : 0) +
          finishCharge(
            preFinishSubtotal()
          );

        if (totalPriceField) {
          totalPriceField.value =
            `$${total.toFixed(2)}`;
        }

        try {
          setLoading(true);

          const invoiceUrl =
            await createDraftOrder(
              total
            );

          window.location.href =
            invoiceUrl;
        } catch (error) {
          console.error(error);

          alert(
            "Could not create checkout. " +
            (error.message || error)
          );
        } finally {
          setLoading(false);
        }
      }
    );
  }

  clearCustomSelections();
  setActiveStep(1);
  refresh(false);
  warmPreloadAllPreviewAssets();
});